import { ChromePicker } from 'react-color';
import DialogWrapper from '../../dialog/dialog_wrapper';
import formStyle from '../style/WForm.less';
import { i18n } from '../../../i18n/i18n';
import * as React from 'react';
import { WActionButton } from '../../../core/elements/WActionButton';

interface WFormFieldColorProps extends React.ClassAttributes<any> {
    label?: JSX.Element;
    name: string;
    value: string;
    inList?: boolean;
    onValueChange(name: string, value: any): void;
    toDraggingAfterClose?(): void;
    makeDefault?(): void;
}

interface WFormFieldColorState extends React.ClassAttributes<any> {
    showPicker: boolean;
    value: string;
}

export class WFormFieldColor extends React.Component<WFormFieldColorProps, WFormFieldColorState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showPicker: false,
            value: this.props.value ? this.props.value : '#FFFFFF'
        };
        this.onInputChange = this.onInputChange.bind(this);
    }

    onInputChange(color: string) {
        this.props.onValueChange(this.props.name, color);
    }

    render() {
        if (this.state.showPicker) {
            return (
                <div>
                    <DialogWrapper
                        title=''
                        onAfterClose={() => {
                            this.setState({ showPicker: false });
                            if (this.props.toDraggingAfterClose) {
                                this.props.toDraggingAfterClose();
                            }
                        }}
                    >
                        <div className={formStyle.colorButtonsWrapper}>
                            <WActionButton
                                label={i18n('Speichern', 'sys')}
                                action='tableRowSave'
                                onAction={() => {
                                    this.setState({ showPicker: false });
                                    if (this.props.toDraggingAfterClose) {
                                        this.props.toDraggingAfterClose();
                                    }
                                }}
                            />
                            <input
                                type='button'
                                value={i18n('Standardfarbe', 'sys')}
                                onClick={() => {
                                    this.setState({ value: '' });
                                    if (this.props.makeDefault) {
                                        this.props.makeDefault();
                                    }
                                }}
                            />
                        </div>
                        <ChromePicker
                            color={this.state.value}
                            disableAlpha={true}
                            onChangeComplete={(color) => { this.setState({ value: color.hex }); this.onInputChange(color.hex); }}
                        />
                    </DialogWrapper>
                </div>
            );
        } else {
            return (
                <div className={formStyle.fieldBox}>
                    {this.props.label}
                    <div className={formStyle.inputColor}>
                        <div className={formStyle.colorPickerWrapper}
                            style={this.props.inList ? { margin: 'auto' } : null}>
                            <div className={formStyle.colorPicker}
                                style={{ backgroundColor: this.state.value }}
                                onClick={() => this.setState({ showPicker: true })}></div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}
